const $domElements = {
  predictiveSearchDesktop: document.querySelector('.predictive-search-container'),
  mobileSearch: document.querySelector('.predictive-search-mobile-container .mobile-search-js'),
  mobileSearchOverlay: document.querySelector('.predictive-search-mobile-container .overlay'),
};

const $helperVariables = {
  isMobileSearchVisible: false,
};

/**
 * Toggle mobile search overlay.
 *
 * @return  {void}
 */
const toggleOverlay = () => {
  if ($helperVariables?.isMobileSearchVisible === true) {
    document.body.classList.add(`overflow-hidden-tablet`);
    $domElements.mobileSearchOverlay?.classList?.add('visible');
  } else {
    document.body.classList.remove(`overflow-hidden-tablet`);
    $domElements.mobileSearchOverlay?.classList?.remove('visible');
  }
};

/**
 * Toggle mobile search bar.
 *
 * @return  {void}
 */
const toggleMobileSearch = () => {
  $domElements.predictiveSearchDesktop?.classList?.toggle('small-hide');
  $domElements.predictiveSearchDesktop?.classList?.toggle('medium-hide');
  $domElements.predictiveSearchDesktop?.classList?.toggle('medium-large-hide');
  $helperVariables.isMobileSearchVisible = !$helperVariables.isMobileSearchVisible;
  toggleOverlay();
  const isHeaderMenuOpened = document.querySelector('.menu-drawer-container.menu-opening');
  isHeaderMenuOpened?.querySelector('summary')?.click();
};

document.addEventListener('DOMContentLoaded', () => {
  if ($domElements.mobileSearch) {
    $domElements.mobileSearch?.addEventListener('click', toggleMobileSearch);
    $domElements.mobileSearchOverlay?.addEventListener('click', toggleMobileSearch);
  }
});
